module.exports = require('mapbox-gl-style-spec/reference/v7');
